import { CatalogMap } from './_map'

type CatalogView = 'list' | 'map'

/**
 * Инициализирует переключатель видов каталога между списком и картой
 * @param {Object} params - Параметры инициализации
 * @param {HTMLElement} params.catalogElement - Элемент каталога
 * @param {CatalogMap} params.map - Экземпляр карты каталога
 */
export function initCatalogViewSwitch({
  catalogElement,
  map
}: {
  catalogElement: HTMLElement
  map: CatalogMap
}) {
  let currentView: CatalogView = 'list'

  /**
   * Обновляет текущий вид каталога (список или карта)
   * @param {CatalogView} view - Новый вид для отображения
   */
  const updateView = (
    view: CatalogView,
    { shouldScroll = false }: { shouldScroll?: boolean } = {}
  ) => {
    if (view === 'map') {
      catalogElement.classList.add('catalog_view_map')
      map.show()
    } else {
      catalogElement.classList.remove('catalog_view_map')
    }

    if (shouldScroll) {
      catalogElement.scrollIntoView({ behavior: 'smooth' })
    }
    currentView = view
  }

  catalogElement.addEventListener('click', (e) => {
    const switchBtn = (e.target as HTMLElement).closest(
      '[data-change-view]'
    ) as HTMLElement

    if (!switchBtn) return
    if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || e.button !== 0)
      return

    // Preserve current filters; the link's href handles native navigation without JS or with modifiers.
    e.preventDefault()

    const view = switchBtn.getAttribute('data-change-view') as CatalogView
    if (view === currentView) return

    updateView(view, { shouldScroll: true })
  })

  updateView(currentView)
  observeVisibility()
}

/**
 * Отслеживает видимость футера и скрывает элемент переключателя вида на мобильных устройствах
 */
function observeVisibility(): void {
  const changeTypeWrapper =
    document.querySelector<HTMLDivElement>('[data-change-view]')

  const mediaQuery = window.matchMedia('(max-width: 1023px)')

  if (!changeTypeWrapper) return

  const footer = document.querySelector<HTMLElement>('.footer')

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        changeTypeWrapper.classList.toggle(
          'is-hidden',
          entry.isIntersecting && mediaQuery.matches
        )
      })
    },
    { rootMargin: '0px', threshold: 0.1 }
  )

  if (footer) {
    observer.observe(footer)
  }
}
